export default __webpack_public_path__ + "static/media/640_store01-it-web.da3bfc45.png";